import { Routes, Route, Navigate } from 'react-router-dom';
import { ProjectScope } from '../../components/ProjectScope';
import { Dashboard } from './Dashboard';
import { Packages, PackageDetail } from './Packages';
import { Orders } from './Orders';
import { Deliveries } from './Deliveries';

export function ProcRoutes() {
  return (
    <ProjectScope
      storageKey="munin.proc.project"
      emptyBody="Paket procurement menggantung pada sebuah proyek, BOQ-nya, dan tujuh langkah di programme-nya. Buat proyek lebih dulu."
    >
      {(projectId) => (
        <Routes>
          <Route path="/" element={<Dashboard projectId={projectId} />} />
          <Route path="/packages" element={<Packages projectId={projectId} />} />
          <Route path="/packages/:id" element={<PackageDetail />} />
          <Route path="/orders" element={<Orders projectId={projectId} />} />
          <Route path="/deliveries" element={<Deliveries projectId={projectId} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      )}
    </ProjectScope>
  );
}
